import React from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  Grid,
  ControlLabel,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import Card from "../../../../components/Card/Card";
import "./BriefingItemStyles.scss";
import moment from "moment";

const BriefingItem = ({ data, hasAdmin, onDelete }) => {
  return (
    <Card
      content={
        <Row>
          <Form>
            <Grid fluid>
              <Row>
                <Col xs={12} sm={6}>
                  <FormGroup>
                    <ControlLabel>
                      <b>Date</b>
                    </ControlLabel>
                    <FormControl
                      type="text"
                      value={moment(data.updatedAt).format("MMMM DD, YYYY")}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} sm={6}>
                  <FormGroup>
                    <ControlLabel>
                      <b>Created By</b>
                    </ControlLabel>
                    <FormControl type="text" value={data.createdBy} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <ControlLabel>
                      <b>Briefing</b>
                    </ControlLabel>
                    <div
                      className="briefing-content"
                      dangerouslySetInnerHTML={{
                        __html: data.notes,
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Grid>
          </Form>
          {hasAdmin && (
            <Col style={{ marginLeft: 20 }}>
              <div className="actions-center">
                <Link to={`/admin/briefing/${data.id}`}>
                  <Button bsStyle="warning" simple icon>
                    <i
                      className="pe-7s-pen action-icon"
                      style={{ color: "blue" }}
                    />
                  </Button>
                </Link>
                <Button
                  bsStyle="danger"
                  simple
                  icon
                  onClick={() => onDelete(data.createdBy, data.id)}
                >
                  <i className="pe-7s-trash action-icon" />
                </Button>
              </div>
            </Col>
          )}
        </Row>
      }
    />
  );
};

export default BriefingItem;
